import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30.324}
      height={30.324}
      viewBox="0 0 30.324 30.324"
      {...props}
    >
      <path
        data-name="Path 12"
        d="M10.798 23.381l-4.373 2.616a3.956 3.956 0 00-.7.548 13.672 13.672 0 0018.818.053 3.877 3.877 0 00-.773-.566l-4.684-2.568a1.986 1.986 0 01-.987-1.752v-2.014c.132-.164.282-.375.443-.625a12.308 12.308 0 001.456-3.217 1.6 1.6 0 001.043-1.534v-2.151a1.676 1.676 0 00-.49-1.192V7.871s.584-4.839-5.391-4.839S9.768 7.87 9.768 7.87v3.109a1.674 1.674 0 00-.49 1.192v2.151a1.654 1.654 0 00.678 1.353 11.07 11.07 0 001.773 4.023v1.965a2 2 0 01-.931 1.718z"
        fill="#e7eced"
      />
      <g data-name="Group 1">
        <path
          data-name="Path 13"
          d="M15.422 0A15.108 15.108 0 000 14.786a14.948 14.948 0 005.4 11.758 4.029 4.029 0 01.719-.507l4.524-2.448a1.831 1.831 0 00.963-1.609v-1.841a9.952 9.952 0 01-1.834-3.765 1.507 1.507 0 01-.7-1.266v-2.014a1.5 1.5 0 01.507-1.115v-2.91s-.6-4.528 5.579-4.528 5.579 4.528 5.579 4.528v2.91a1.5 1.5 0 01.507 1.115v2.013a1.511 1.511 0 01-1.079 1.436 11.024 11.024 0 01-1.506 3.011 7.267 7.267 0 01-.458.585v1.886a1.831 1.831 0 001.021 1.639l4.845 2.4a4.036 4.036 0 01.8.529A15.013 15.013 0 0015.422 0z"
          fill="#ffd200"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
